module.exports = __webpack_public_path__ + "img/deposit.99964bc6.svg";